import { criarFinalizador } from '@/uteis/action/desatribuir/finalizador'
import { criarDestino } from '@/uteis/action/desatribuir/destino'

export const desatribuir = (processo, dadosSessao) => {
  var dados = {
    motivo: 'Desatribuir',
    descricao: 'Fazendo rollback',
    processo: processo.processo,
    finalizador: criarFinalizador(dadosSessao),
    destino: criarDestino(dadosSessao)
  }

  return dados
}
